/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { CompetenceListItemViewModel } from "../types/CompetenceListItemViewModel.ts";

export const competenceListItemViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID da competência.")),
  name: z.string().describe("Nome da competência.").nullish(),
}) as unknown as ToZod<CompetenceListItemViewModel>;
